import React, { useEffect, useState } from "react";
import { Spinner, Table, Button } from "react-bootstrap";
import IndicadorCard from "../../components/IndicadorCard";
import { useAuth } from "../../auth/AuthContext";
import * as dashboardApi from "../../api/dashboard";
import * as reportesApi from "../../api/reportes";

export default function AdminDashboard() {
  const { monedaPredeterminada } = useAuth();
  const [resumen, setResumen] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    dashboardApi.dashboardAdmin().then(setResumen).finally(() => setCargando(false));
  }, []);

  if (cargando) return <Spinner animation="border" />;
  if (!resumen) return null;

  const hoy = new Date();

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h4 className="mb-0">Dashboard Administrador — Vista global</h4>
        <Button
          size="sm"
          variant="primary"
          onClick={() => reportesApi.descargarAdminPdf(hoy.getMonth() + 1, hoy.getFullYear())}
        >
          <i className="bi bi-file-earmark-pdf me-1"></i>Imprimir reporte global
        </Button>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <IndicadorCard label="Ingresos del mes" valor={resumen.ingresosMesSistema} tono="ingreso" icono="bi-arrow-down-circle" />
        </div>
        <div className="col-6 col-md-3">
          <IndicadorCard label="Gastos esporádicos del mes" valor={resumen.gastosEsporadicosMesSistema} tono="gasto" icono="bi-cart" />
        </div>
        <div className="col-6 col-md-3">
          <IndicadorCard label="Gastos fijos cobrados del mes" valor={resumen.gastosFijosPagadosMesSistema} tono="gasto" icono="bi-receipt" />
        </div>
        <div className="col-6 col-md-3">
          <IndicadorCard label="Saldo total actual" valor={resumen.saldoTotalSistema} icono="bi-wallet2" />
        </div>
      </div>

      <h6 className="mb-2">Saldo por usuario</h6>
      <div className="fs-card p-0 overflow-hidden">
        <Table responsive hover className="table-fs mb-0 align-middle">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Email</th>
              <th># Cuentas</th>
              <th className="text-end">Saldo total</th>
            </tr>
          </thead>
          <tbody>
            {resumen.porUsuario.map((u) => (
              <tr key={u.usuarioId}>
                <td>{u.nombres}</td>
                <td className="text-muted">{u.email}</td>
                <td>{u.numeroCuentas}</td>
                <td className="text-end fw-semibold">
                  {u.saldoTotal.toLocaleString("es-ES", { style: "currency", currency: monedaPredeterminada.codigo })}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
